import AnalyzedTextEnglish, { AnalyzerSection } from './AnalyzedTextEnglish';
import AnalyzedTextSpanish from './AnalyzedTextSpanish';
import AnalyzedTextCatalan from './AnalyzedTextCatalan';
import AnalyzedTextRussian from './AnalyzedTextRussian';

export interface AnalyzedTextProps {
    task_id: string;
    analyzedText: any;
    saveFormattedTextCallback: CallableFunction;
    language?: string;
    section?: AnalyzerSection;   // només l'anglès reparteix els grups en pestanyes
}

export default function AnalyzedText(props: AnalyzedTextProps) {
    const language = props.language || 'en';

    switch (language) {
        case 'en':
            return <AnalyzedTextEnglish {...props} />;
        case 'es':
            return <AnalyzedTextSpanish {...props} />;
        case 'ca':
            return <AnalyzedTextCatalan {...props} />;
        case 'ru':
            return <AnalyzedTextRussian {...props} />;
        default:
            return <AnalyzedTextEnglish {...props} />;
    }
}
